import { Input } from '@/components/ui/input.js';
import { t } from '@/lib/i18n/messages.js';
import { cn } from '@/lib/utils.js';

interface NumberParamProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  min?: number | undefined;
  max?: number | undefined;
  disabled?: boolean | undefined;
  error?: string | undefined;
  required?: boolean | undefined;
}

export function NumberParam({
  id,
  value,
  onChange,
  min,
  max,
  disabled,
  error,
  required,
}: NumberParamProps) {
  function interpolate(template: string, values: Record<string, string | number>): string {
    return template.replace(/\{(\w+)\}/g, (_, key: string) => String(values[key] ?? ''));
  }

  let validationError = error;
  if (validationError === undefined && value.length > 0) {
    const n = Number(value);
    if (Number.isNaN(n)) {
      validationError = t('params.invalid_number');
    } else if (min !== undefined && n < min) {
      validationError = interpolate(t('params.min'), { min });
    } else if (max !== undefined && n > max) {
      validationError = interpolate(t('params.max'), { max });
    }
  }

  return (
    <>
      <Input
        id={id}
        type="number"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        min={min}
        max={max}
        disabled={disabled}
        error={validationError !== undefined}
        required={required}
        aria-required={required === true ? true : undefined}
        aria-describedby={validationError !== undefined ? `${id}-error` : undefined}
        className={cn('w-full')}
      />
      {validationError !== undefined && (
        <span
          id={`${id}-error`}
          role="alert"
          className="mt-1 block text-xs text-[var(--color-qup-error)]"
        >
          {validationError}
        </span>
      )}
    </>
  );
}
